define([], function() {
  /**
   * The exported modeles here are used by the Mindbreeze.require([...])
   * The internal define([...]) is already recognizing the modules based on the resolve.alias in the webpack-config files
   */
  return function getModuleMap() {

    var moduleMap = {};

    moduleMap["underscore"] = require("underscore");
    moduleMap["text"] = require("libs/text");
    moduleMap["saveAs"] = require("libs/FileSaver");
    moduleMap["jquery"] = require("jquery");
    moduleMap["jquery-taphold"] = require("libs/jquery-taphold");
    moduleMap["jquery-migrate"] = require("libs/jquery-migrate-3.4.1");
    moduleMap["mustache"] = require("mustache");
    moduleMap["mbmustache"] = require("mbmustache");
    moduleMap["utils/lzma-url"] = require("utils/lzma-url");
    moduleMap["utils/lzma-helper"] = require("utils/lzma-helper");
    moduleMap["utils/backbone-utils"] = require("utils/backbone-utils");
    moduleMap["client/extensions"] = require("client/extensions");
    moduleMap["client/export"] = require("client/export");
    moduleMap["client/application"] = require("client/application");
    moduleMap["client/templates"] = require("client/templates");
    moduleMap["client/loader"] = require("client/loader");
    moduleMap["client/client-config"] = require("client/client-config");
    moduleMap["client/settings"] = require("client/settings");
    moduleMap["client/queryprofiler"] = require("client/queryprofiler");
    moduleMap["i18n/i18n"] = require("i18n/i18n");
    moduleMap["utils/csv"] = require("utils/csv");
    moduleMap["utils/string"] = require("utils/string");
    moduleMap["utils/browser"] = require("utils/browser");
    moduleMap["utils/url"] = require("utils/url");
    moduleMap["service/channels"] = require("service/channels");

    moduleMap["api/v2/search"] = require("api/v2/search");
    moduleMap["api/v2/api"] = require("api/v2/api");
    moduleMap["api/v1/mindbreeze/client/notification"] = require("api/v1/mindbreeze/client/notification");

    //Components
    moduleMap["component!accordion"] = require("component!accordion");
    moduleMap["component!alert"] = require("component!alert");
    moduleMap["component!answers"] = require("component!answers");
    moduleMap["component!chat"] = require("component!chat");
    moduleMap["component!applists"] = require("component!applists");
    moduleMap["component!channels"] = require("component!channels");
    moduleMap["component!collect"] = require("component!collect");
    moduleMap["component!constraints"] = require("component!constraints");
    moduleMap["component!datasources"] = require("component!datasources");
    moduleMap["component!exportview"] = require("component!exportview");
    moduleMap["component!feedbackbutton"] = require("component!feedbackbutton");
    moduleMap["component!clientnotification"] = require("component!clientnotification");
    moduleMap["component!filteredfacet"] = require("component!filteredfacet");
    moduleMap["component!filteredfacets"] = require("component!filteredfacets");
    moduleMap["component!groupswitch"] = require("component!groupswitch");
    moduleMap["component!include"] = require("component!include");
    moduleMap["component!inputdate"] = require("component!inputdate");
    moduleMap["component!inputnumber"] = require("component!inputnumber");
    moduleMap["component!inputregex"] = require("component!inputregex");
    moduleMap["component!listview"] = require("component!listview");
    moduleMap["component!menu"] = require("component!menu");
    moduleMap["component!mustache"] = require("component!mustache");
    moduleMap["component!pages"] = require("component!pages");
    moduleMap["component!pagination"] = require("component!pagination");
    moduleMap["component!patternconstraints"] = require("component!patternconstraints");
    moduleMap["component!personalize"] = require("component!personalize");
    moduleMap["component!preview"] = require("component!preview");
    moduleMap["component!profilesettings"] = require("component!profilesettings");
    moduleMap["component!profilesettingsview"] = require("component!profilesettingsview");
    moduleMap["component!resultsprogress"] = require("component!resultsprogress");
    moduleMap["component!searchinfo"] = require("component!searchinfo");
    moduleMap["component!searchroot"] = require("component!searchroot");
    moduleMap["component!searchform"] = require("component!searchform");
    moduleMap["component!searchsettings"] = require("component!searchsettings");
    moduleMap["component!settings"] = require("component!settings");
    moduleMap["component!sortswitch"] = require("component!sortswitch");
    moduleMap["component!suggest"] = require("component!suggest");
    moduleMap["component!stack"] = require("component!stack");
    moduleMap["component!results"] = require("component!results");
    moduleMap["component!stepper"] = require("component!stepper");
    moduleMap["component!tabs"] = require("component!tabs");
    moduleMap["component!table"] = require("component!table");
    moduleMap["component!tasksmonitor"] = require("component!tasksmonitor");
    moduleMap["component!treeview"] = require("component!treeview");
    moduleMap["component!view"] = require("component!view");
    moduleMap["component!voting"] = require("component!voting");

    return moduleMap;
  }

});
